import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What are animation explainer videos? How can they help me?",
    answer: `<p>Animation explainer videos are usually 2D animated. The purpose of these type of videos is to portray your product or company’s story with characters, and objects that engage, and excite your audience so they can extract value in quick time. </p>`,
  },
  {
    question: "What is SaaS video production?",
    answer: `<p>SaaS video production is a specialized process executed by software demo video agencies. It entails creating marketing content for companies and tech teams that specialize in Software as a Service (SaaS) niche. </p>`,
  },
  {
    question: "How to make a SaaS video?",
    answer: ` <p>Here’s how to make a SaaS video in four simple and easy steps:</p>
    <ul>
    <li>Gather your tool’s demo video, photos and screenshots</li>
    <li>Collect stock footage, photos, music, texts</li>
    <li>Include motion art or outsource to a software demo video agency</li>
    <li>Include custom voiceover, and edit for final launch</li>
    </ul>`,
  },
  {
    question: "What is SaaS animation?",
    answer: ` <p>SaaS animation or SaaS product videos are made to educate people on how to use a certain software platform. It is a promotion video that shows how to use it for maximum benefit. It’s better than texts and long technical guides as most people are not tech savvy.</p>`,
  },
  {
    question: "How Much Does SaaS Video Production Cost?",
    answer: ` <p>SaaS video production cost mainly depends upon the style of video, quality, and your ultimate needs for the project. The cost can vary between $1000 and $10000. Price usually goes up for the length, number of videos, quality of animation, detailing, and shorter timeline.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>SaaS Video Production FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
